import React from 'react';
import { Box, Typography } from '@mui/material';
import { ShieldAlert } from 'lucide-react';
import Layout from '../components/Layout';
import LoginHistoryPanel from '../components/LoginHistoryPanel';

const styles = {
  container: { padding: '48px' },
  header: { display: 'flex', alignItems: 'center', gap: '8px', mb: '8px' },
  subHeader: { mb: '32px' },
  title: { fontSize: '24px', fontWeight: 700 },
  contentBox: { backgroundColor: '#FFFFFF', p: '32px', borderRadius: '8px' },
};

const LoginHistoryPage = ({ user, accessToken }) => {
  return (
    <Layout profilePic={user.picture}>
      <Box sx={styles.container}>
        <Box sx={styles.header}>
          <ShieldAlert size={24} />
          <Typography sx={styles.title}>Login History</Typography>
        </Box>
        <Box sx={styles.subHeader}>
          <Typography variant="body2" gutterBottom>
            Login attempts across all dashboards. Defaults to unauthorized and failed attempts, including unprovisioned
            Google SSO.
          </Typography>
        </Box>
        <Box sx={styles.contentBox}>
          <LoginHistoryPanel accessToken={accessToken} />
        </Box>
      </Box>
    </Layout>
  );
};

export default LoginHistoryPage;
